var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown-wrapper"},[_c('span',{staticClass:"font-bold text-6xl text-purple-gradient"},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }